
export const PAYMENT_ORDER_ERROR = {
    ORDER_POLICIES: 'ORDER_POLICIES_ERROR',
    ORDER_CONFIRM_MONEY: 'NOT_ENOUGH_MONEY',
    NOT_MATCH_STATUS: 'not_match_status',
};
